<template>
  <div class="layout-default">
    <v-app>
      <layout-dektop
        v-if="$vuetify.breakpoint.lgAndUp"
        :img-logo="cliente.imgLogo"
      />
      <layout-mobile
        v-if="$vuetify.breakpoint.mdAndDown"
        :img-logo="cliente.imgLogo"
      />
      <snackbar-messages />
    </v-app>
  </div>
</template>

<script>
import MixinGlobal from "@/mixins";
import LayoutDektop from "./desktop";
import LayoutMobile from "./mobile";
import SnackbarMessages from "@/components/snackbars/snackbar-messages";
export default {
  mixins: [MixinGlobal],
  components: { SnackbarMessages, LayoutDektop, LayoutMobile },
  beforeRouteEnter(to, from, next) {
    next((_this) => {
      if (
        (_this.$store.state.auth.statusAccounts === 0 &&
          to.path.includes("pet") &&
          _this.$store.state.context !== "pet") ||
        (!to.path.includes("pet") &&
          _this.$store.state.context !== "pessoa" &&
          _this.$store.state.context !== "tagFuncionario")
      ) {
        return _this.$router.push("/login");
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.$store.commit("setShowModalDataForm", false);
    next();
  },
  computed: {
    auth() {
      return this.$store.state.auth.user;
    },
    cliente() {
      return this.$store.state.cliente.data || {};
    },
  },
  beforeMount() {
    this.$store.commit("setSnackbarSuccess", {
      status: false,
    });
    this.$store.commit("setSnackbarError", {
      status: false,
    });
  },
  mounted() {
    setTimeout(() => {
      this.$store.commit("setSnackbarLoading", {
        message: this.$t("atualizando_aguarde"),
        status: true,
      });

      if (this.$store.state.context)
        if (this.$store.state.auth.user.token) {
          this.$store.dispatch(this.$store.state.context + "/getAdminData", {
            token: this.$store.state.auth.user.token,
            callbackSuccess: (data) => {
              this.$store.commit("setSnackbarLoading", {
                status: false,
              });

              // obtem o cliente vinculado com o qrcode, se existir.
              if (data.cliente) {
                this.$store.commit("cliente/setData", data.cliente);
              }
            },
            callbackError: (err) => {
              this.$store.commit("setSnackbarLoading", {
                status: false,
              });
              this.$store.commit("setSnackbarError", {
                message:
                  err && [401, 403].includes(err.status)
                    ? this.$t("sessao_expirada")
                    : this.$t("erro_inesperado_tente_novamente"),
                status: true,
              });
              this.revokeAuth(err);
            },
          });
        } else {
          this.$store.dispatch(this.$store.state.context + "/getData", {
            callbackSuccess: (data) => {
              this.$store.commit("setSnackbarLoading", {
                status: false,
              });

              // obtem o cliente vinculado com o qrcode, se existir.
              if (data.cliente) {
                this.$store.commit("cliente/setData", data.cliente);
              }
            },
            callbackError: (err) => {
              this.$store.commit("setSnackbarLoading", {
                status: false,
              });
              this.$store.commit("setSnackbarError", {
                message:
                  err && [401, 403].includes(err.status)
                    ? this.$t("sessao_expirada")
                    : this.$t("erro_inesperado_tente_novamente"),
                status: true,
              });
              this.revokeAuth(err);
            },
          });
        }
    }, 90);
  },
};
</script>
